export const slugify = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
};

// Navigation path to section slug mapping
// Matches ALL_NAV_LINKS paths in Navbar.js
export const NAV_TO_SECTION = {
  'dashboard': 'dashboard',
  'my-tasks': 'my-tasks',
  'billings': 'billings',
  'billing-settings': 'billing-settings',
  'device-orders': 'device-orders',
  'case-manager': 'case-manager',           // Account Insights
  'user-settings': 'user-settings',
  'admin/dashboard': 'admin-dashboard',     // Admin
  'executive-dashboard': 'executive-dashboard',
};

// Reverse mapping
export const SECTION_TO_NAV = Object.entries(NAV_TO_SECTION).reduce(
  (acc, [nav, section]) => {
    acc[section] = nav;
    return acc;
  },
  {}
);

export const getAllNavItems = () => Object.keys(NAV_TO_SECTION);

export const getSectionFromNav = (navPath) => NAV_TO_SECTION[navPath] || null;

export const getNavFromSection = (sectionSlug) => SECTION_TO_NAV[sectionSlug] || null;

